export default {
  label: '产品经理',
  id: '0',
  children: [
    {
      label: '定义',
      id: '0-1',
      children: [
        {
          label: '产品的“迷你CEO”，负责全生命周期管理。',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '职责',
      id: '0-2',
      children: [
        {
          label: '主导产品设计和开发，从宏观视角定义产品功能和用户体验。',
          id: '0-2-1',
        },
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '具备良好的市场洞察力和用户需求分析能力，能够协调跨部门合作。',
          id: '0-3-1',
        },
      ],
    },
    {
      label: '职业发展',
      id: '0-4',
      children: [
        {
          label: '通常在5年以上经验后晋升为产品总监。',
          id: '0-4-1',
        },
      ],
    },
    {
      label: '薪资水平',
      id: '0-5',
      children: [
        {
          label: '月薪8,000-25,000元之间，年薪约为25-50万元。',
          id: '0-5-1',
        },
      ],
    },
  ],
};